import React, { FC, useState } from "react";
import ReviewFilterItem from "./ReviewFilterItem";
import OverflowScroll from "../common/OverflowScroll";

const data = [
  {
    code: "SUPER",
    name: "Все супер!"
  },
  {
    code: "POOR",
    name: "У меня есть предложение"
  },
  {
    code: "BAD",
    name: "Все плохо"
  }
];

interface Props {
  centerWidth?: number;
  onChange?: any;
}
const ReviewFilter: FC<Props> = ({ centerWidth, onChange, ...props }) => {
  const [active, setActive] = useState<number | null>(null);

  return (
    <OverflowScroll space={20} {...props}>
      {data.map((i, index) => (
        <ReviewFilterItem
          key={index}
          index={index}
          active={active}
          setActive={setActive}
          onChange={onChange}
          {...i}
        />
      ))}
    </OverflowScroll>
  );
};

export default ReviewFilter;
